import type { OpenRoleFilters } from '@/types/openRole'

// No source = community + discover (Basecamp falls back to community for users without the Discover tab).
const SOURCE_FILTERS: Record<string, OpenRoleFilters['is_scraped']> = { community: false, discover: true }

/**
 * Converts URL query parameters to OpenRoleFilters object
 * @param query - The query object from the URL
 * @returns Partial OpenRoleFilters object
 */
export const urlToFilters = (query: any): Partial<OpenRoleFilters> => {
  const filters: Partial<OpenRoleFilters> = {
    time_posted: query.date && query.date !== 'all' ? (query.date as string) : undefined,
    seniority_level:
      query.experience && query.experience !== 'all' ? (query.experience as string) : undefined,
    country_ids: query.country_ids
      ? Array.isArray(query.country_ids)
        ? query.country_ids.map(Number)
        : [Number(query.country_ids)]
      : undefined,
    location_ids: query.location_ids
      ? Array.isArray(query.location_ids)
        ? query.location_ids.map(Number)
        : [Number(query.location_ids)]
      : undefined,
    employer_ids: query.employer_ids
      ? Array.isArray(query.employer_ids)
        ? query.employer_ids.map(Number)
        : [Number(query.employer_ids)]
      : undefined,
    is_scraped: SOURCE_FILTERS[query.source as string] ?? 'all'
  }

  // Handle status_open specifically
  if (query.status === 'all') {
    // Don't include status_open in filters for "All jobs"
  } else if (query.status === 'true') {
    filters.status_open = true
  } else if (query.status === 'false') {
    filters.status_open = false
  } else {
    // Default to open jobs if no status specified
    filters.status_open = true
  }

  return filters
}
